import React from 'react';

import { connect, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom';

import pageWithSideMenu from '../../containers/pageWithSideMenu'
import pageContent from '../../containers/pageContent'

import { Breadcrumb, Card } from 'react-bootstrap'
import InvalidPermissions from '../../containers/InvalidPermissions'
import LanderTable from './LanderTable';

const LanderListing = (props) => {
    let { landerType } = useParams();
    const isSysadmin = useSelector((state) => state.user.isSysadmin)

    const pathName = () => {
        var str = landerType ?? ''
        return str.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') + ' Landing Pages';
      }
    

    if(!isSysadmin) return <InvalidPermissions />

    return (
        <>
        <Breadcrumb>
          <Breadcrumb.Item href="/landers/">Landing Pages</Breadcrumb.Item>
          <Breadcrumb.Item active>{pathName()}</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
            <LanderTable showDetailsOnClick={true} cascadeType={landerType} title={pathName()} description={`Listing of current ${pathName()} landing pages`} />
        </Card>
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(LanderListing), "Landing Pages"));
